module.exports = __webpack_public_path__ + "static/media/logo_atise.c3ff6029.svg";